import { HiwItems } from "./types";

export const step1Items: HiwItems = [
  {
    question: "How do you decide my budget?",
    answer:
      "It’s based on your income and the income of any fellow applicants. We want to make sure your monthly maximum is not higher than what you could afford.",
  },
  {
    question: "What is the basic eligibility criteria?",
    answer:
      'You will need to be over 18 and have the right to live in the UK. We will also do an industry-standard check on you using secure and modern technology including: <ul class="pl-10 list-disc"><li>Verifying your income and outgoings (using Open Banking)</li><li>Checking for fraud and bankruptcy (using Credit bureaus)</li><li>Reference checks with landlords and employers</li></ul>',
  },
  {
    question: "How is Keyzy able to give back all my rent and still make money?",
    answer:
      "Keyzy is a rent-to-own company. We exist to sell homes to first time buyers and help people onto the property ladder. We’ve got no interest in being long-term landlords. We make money by selling the home to you at the end of your 2-year tenancy. We work with investors and developers to make lots of new-build homes available on our rent-to-own product. We believe in this model because we know there are loads of people out there who want to buy a home but need a little help to get ready before they do. There is also a one-off capital payment made on the grant of your contractual right to buy your home — this is your Future Purchase Agreement. It costs £499 for 1 applicant, £999 for 2, or £1,499 for 3 or more. After that, the only thing you pay to us is your monthly rent.",
  },
];
